const deleteFile = () => { }

export { deleteFile }
